import axios from "axios";
import { api_url, PLATFORM } from "../../config";
import { AUTH_TYPES } from "../reducers/authReducers";
import { ERROR_TYPES } from "../reducers/errorReducers";
import jwt_decode from "jwt-decode";
import { MESSAGE_SERVEUR_INDISPONIBLE } from "../../components/common/HorsConnexion/horsConnexion";

export const authActions = (state, dispatch) => {
  /** Termine la connexion à partir d'un texte « Bearer <jwt> » (connexion directe ou après le code MFA). */
  function ouvrirSession(token) {
    // Set token to ls
    localStorage.setItem("jwtToken", token);
    // Set token to Auth header
    //tools.setAuthToken(token);
    // Set current user
    dispatch({
      type: AUTH_TYPES.SET_CURRENT_USER,
      payload: jwt_decode(token),
    });
    dispatch({
      type: ERROR_TYPES.CLEAR_ERRORS,
    });
  }

  /**
   * Verse l'erreur d'authentification dans state.errors, sans toast : la carte
   * de connexion affiche elle-même chaque clé du contrat (login, password,
   * other + nbAttempts, error + timer, code, restart, retryIn…). Sans réponse
   * du serveur, un message générique prend la place du toast « Erreur interne ».
   */
  function signalerErreurConnexion(err) {
    const reponse = err && err.response;
    const donnees = reponse && reponse.data;
    let payload;
    if (!reponse) payload = { other: MESSAGE_SERVEUR_INDISPONIBLE };
    else if (donnees && typeof donnees === "object") payload = donnees;
    else if (donnees === "Unauthorized") payload = donnees; // traduit par errorReducers (session expirée)
    else payload = { other: donnees || `Erreur ${reponse.status}` };
    dispatch({ type: AUTH_TYPES.LOAD_CURRENT_USER, payload: false });
    dispatch({ type: ERROR_TYPES.GET_ERRORS, payload });
  }

  function loginUser(userData, onMfa) {
    // fetch api
    localStorage.clear();
    axios
      .post(`${api_url}auth/login/${PLATFORM}`, userData)
      .then((res) => {
        if (res.status === 202 && res.data && res.data.mfa) {
          // Un code de vérification a été envoyé par e-mail : on attend sa saisie avant d'ouvrir la session.
          dispatch({ type: ERROR_TYPES.CLEAR_ERRORS });
          onMfa && onMfa(res.data);
          return;
        }
        ouvrirSession(res.data);
      })
      .catch((err) => {
        signalerErreurConnexion(err);
      });
  }

  function verifyMfaCode({ challenge, code }) {
    return axios
      .post(`${api_url}auth/login/${PLATFORM}/mfa`, { challenge, code })
      .then((res) => ouvrirSession(res.data))
      .catch((err) => {
        signalerErreurConnexion(err);
      });
  }

  function resendMfaCode({ challenge }, onMfa) {
    return axios
      .post(`${api_url}auth/login/${PLATFORM}/mfa/resend`, { challenge })
      .then((res) => {
        dispatch({ type: ERROR_TYPES.CLEAR_ERRORS });
        onMfa && onMfa(res.data);
      })
      .catch((err) => {
        signalerErreurConnexion(err);
      });
  }

  function logoutUser() {
    // Remove token from localStorage
    localStorage.removeItem("jwtToken");
    // Remove auth header for future requests
    //tools.setAuthToken(false);
    axios.get(api_url + "auth/logout");
    // Set current user to {} which will set isAuthenticated to false
    dispatch({ type: AUTH_TYPES.CLEAR_CURRENT_USER, payload: {} });
    dispatch({ type: ERROR_TYPES.CLEAR_ERRORS, payload: {} });
    //tools.filterAlert("info", "Vous avez été correctement déconnecté.");
  }

  return {
    loginUser,
    logoutUser,
    verifyMfaCode,
    resendMfaCode,
  };
};
